import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { ChangelogTabs } from "@/components/changelog/changelog-tabs"
import { EntryForm } from "@/components/changelog/entry-form"

export const Route = createFileRoute(
  "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/new",
)({
  loader: ({ params }) => ({
    title: "Nova entry",
    path: `/${params.orgSlug}/changelog/services/${params.serviceId}/entries/new`,
  }),
  component: NewEntryPage,
})

function NewEntryPage() {
  const { orgSlug, serviceId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <ChangelogTabs
        orgSlug={orgSlug}
        serviceId={serviceId}
        activeTab="entries"
      />
      <div>
        <h1 className="text-2xl font-bold md:text-3xl">Nova entry</h1>
        <p className="text-muted-foreground">
          Crie uma nova entry no changelog
        </p>
      </div>

      <EntryForm
        serviceId={serviceId}
        organizationSlug={orgSlug}
        onSuccess={() =>
          navigate({
            to: "/$orgSlug/changelog/services/$serviceId/entries",
            params: { orgSlug, serviceId },
          })
        }
      />
    </div>
  )
}
